module.exports = __webpack_public_path__ + "static/media/sk.fc341bbe.svg";